import { styled, Typography } from '@mui/material'

export const HeaderText = styled(Typography)`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.75rem;
  margin-bottom: 80px;
`
